<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange"></SearchField>

    <Table ref="table" :loading="loading" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showIndex="true" :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="etime" slot-scope="params">
        <div v-if="params.params.etime == 2" class="overTime type0">
          即将到期
        </div>
        <div v-if="params.params.etime == 3" class="overTime type1">
          暂未到期
        </div>
        <div v-if="params.params.etime == 1" class="overTime type2">
          已逾期
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceInitialPayment",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'custom',
      getListUrl: 'freightrec',
      breadcrumb: [
        { name: "财务管理" },
        { name: "应收账款管理" },
      ],
      formInline: {},
      formCtrl: [
        // {
        //   label: "月份：",
        //   keyName: "month",
        //   placeholder: "请选择月份",
        //   type: "month",
        // },
        {
          label: "公司名称",
          keyName: "name",
          placeholder: "请填写公司名称",
          type: "text",
        },
        {
          label: "欠款状态",
          keyName: "intimes",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '已逾期', value: 1, },
            { label: '即将到期', value: 2, },
            { label: '暂未到期', value: 3, },
          ],
        },
      ],
      cols: [
        { prop: "name", label: "公司名称" },
        { prop: "member", label: "联系人" },
        { prop: "address", label: "所在地" },
        { prop: "phone", label: "电话" },
        { prop: "repaytime", label: "约定还款日期" },
        { prop: "cmoney", label: "欠款金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "etime", label: "状态", slot: 'etime' },
      ],
      getTotalProperty: ['cmoney'],
      btns: [
        {
          title: "订单列表",
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/finance/viewOrder?shipperid=${id}`
            );
          },
        },
        // {
        //   title: "合同补差",
        //   img: require('@/assets/img/icon_operate_11.png'),
        //   cb: ({ id }) => {
        //     this.$router.push(
        //       `/finance/contractFix?cid=${id}`
        //     );
        //   },
        // },
        {
          title: "还款记录",
          img: require('@/assets/img/pay_history.png'),
          unimg: require('@/assets/img/pay_history_hover.png'),
          cb: ({ id, member }) => {
            this.$router.push(
              `/finance/paymentHistory?shipperid=${id}&pname=${member}`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.main {
  .table-wrap {
    /deep/ .el-table {
      .overTime {
        // width: 14px;
        // height: 14px;
        // border-radius: 100%;
        // display: inline-block;
        // vertical-align: top;
        // margin-top: 7px;
        color: #ffe100;

        &.type1 {
          color: #98e098;
        }

        &.type2 {
          color: #fd5b5b;
        }
      }
    }
  }
}
</style>
